import { React, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { getTime } from '../features/Bookings/utils';
const CancelTrainingDialog = ({ open, onClose, onConfirm, training, players }) => {
  const [applyToAll, setApplyToAll] = useState(false);
  const isAdmin = localStorage.getItem('role_id') === '1';

  const handleApplyToAllChange = (e) => {
    setApplyToAll(e.target.checked);
  };

  const handleConfirm = () => {
    onConfirm(applyToAll); // Передаём состояние чекбокса
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Подтверждение отмены</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography
            variant='h6'
            sx={{ textAlign: 'center' }}
          >
            {training?.info}
          </Typography>
          <Typography
            variant='h6'
            sx={{ textAlign: 'center' }}
          >
            Время начала: {getTime(training?.start_time)}
          </Typography>
          <Typography
            variant='h6'
            sx={{ textAlign: 'center' }}
          >
            Записано игроков: {training?.players}
          </Typography>

          <Typography
            variant='body1'
            sx={{ textAlign: 'center', mt: 2, mb: 3 }}
          >
            Вы уверены, что хотите отменить тренировку?
          </Typography>

          {isAdmin && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={applyToAll}
                  onChange={handleApplyToAllChange}
                  color='primary'
                />
              }
              label='Отменить все тренировки с таким названием?'
            />
          )}
        </DialogContentText>
        {players?.length > 0 && (
          <DialogContentText>
            Следующие игроки должны быть уведомлены об отмене и получат возврат посещения:
            <ul>
              {players.map((player) => (
                <li key={player.id}>{player.name}</li>
              ))}
            </ul>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color='primary'
        >
          Отмена
        </Button>
        <Button
          onClick={handleConfirm}
          color='error'
          variant='contained'
        >
          Подтвердить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelTrainingDialog;
